/// <reference types="vite/client" />

import { getApp, getApps, initializeApp } from 'firebase/app';
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth';

const requiredEnvKeys = [
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_AUTH_DOMAIN',
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_STORAGE_BUCKET',
  'VITE_FIREBASE_MESSAGING_SENDER_ID',
  'VITE_FIREBASE_APP_ID',
] as const;

function getFirebaseConfig() {
  const missingKeys = requiredEnvKeys.filter((key) => !import.meta.env[key]);
  if (missingKeys.length > 0) {
    throw new Error(`Missing Firebase env vars: ${missingKeys.join(', ')}`);
  }

  return {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  };
}

const firebaseApp = getApps().length > 0
  ? getApp()
  : initializeApp(getFirebaseConfig());

const firebaseAuth = getAuth(firebaseApp);

let authReadyPromise: Promise<typeof firebaseAuth> | null = null;

export function getFirebaseAuth() {
  return firebaseAuth;
}

export function initFirebaseAuth() {
  if (!authReadyPromise) {
    authReadyPromise = setPersistence(firebaseAuth, browserLocalPersistence)
      .then(() => firebaseAuth);
  }

  return authReadyPromise;
}
